import React from 'react';
import { Draggable, DraggableProvidedDragHandleProps, Droppable } from 'react-beautiful-dnd';
import { Shippings } from '@app/pages/checkout-app/types';

export const METHOD_DRAG_TYPE = 'METHOD';
export const METHOD_DRAGGABLE_ID_PREFIX = 'method:';

interface DeliveryMethodSectionMethodRowsDroppableProps {
  sectionKey: string;
  showEmptyState: boolean;
  visibleMethodIds: string[];
  deliveryMethodById: Map<string, Shippings>;
  selectedMethodIdStrings: Set<string>;
  draggingMethodId: string | null;
  movingMethodCount: number;
  renderMethodRow: (
    deliveryMethod: Shippings,
    dragHandleProps?: DraggableProvidedDragHandleProps | null,
  ) => React.ReactNode;
}

export const DeliveryMethodSectionMethodRowsDroppable = ({
  sectionKey,
  showEmptyState,
  visibleMethodIds,
  deliveryMethodById,
  selectedMethodIdStrings,
  draggingMethodId,
  movingMethodCount,
  renderMethodRow,
}: DeliveryMethodSectionMethodRowsDroppableProps) => (
  <Droppable droppableId={sectionKey} type={METHOD_DRAG_TYPE}>
    {(droppableProvided, droppableSnapshot) => (
      <div
        ref={droppableProvided.innerRef}
        {...droppableProvided.droppableProps}
        className={`delivery-method-sections__body ${
          droppableSnapshot.isDraggingOver ? 'delivery-method-sections__body--drop-target' : ''
        }`}>
        {showEmptyState && visibleMethodIds.length === 0 && !droppableSnapshot.isDraggingOver && (
          <div className="delivery-method-sections__empty">This section is empty</div>
        )}
        {visibleMethodIds.map((methodId, index) => (
          <Draggable key={methodId} draggableId={`${METHOD_DRAGGABLE_ID_PREFIX}${methodId}`} index={index}>
            {(draggableProvided, draggableSnapshot) => (
              <div
                ref={draggableProvided.innerRef}
                {...draggableProvided.draggableProps}
                className={`delivery-method-sections__method ${
                  draggableSnapshot.isDragging ? 'delivery-method-sections__method--dragging' : ''
                } ${
                  draggingMethodId &&
                  draggingMethodId !== methodId &&
                  selectedMethodIdStrings.has(draggingMethodId) &&
                  selectedMethodIdStrings.has(methodId)
                    ? 'delivery-method-sections__method--moving-with-selection'
                    : ''
                }`}>
                {renderMethodRow(deliveryMethodById.get(methodId), draggableProvided.dragHandleProps)}
                {draggableSnapshot.isDragging && movingMethodCount > 1 && (
                  <span className="delivery-method-sections__moving-count">{movingMethodCount} delivery methods</span>
                )}
              </div>
            )}
          </Draggable>
        ))}
        {droppableProvided.placeholder}
      </div>
    )}
  </Droppable>
);
